import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.rolle-abteilung-setzen';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsRolleAbteilungSetzenEffects {

    RolleAbteilungSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_ROLLE_ABTEILUNG_SETZEN),
        mergeMap((x: ac.PostRolleAbteilungSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postRolleAbteilungSetzen(x.incidentsRolleOptionenRequest).pipe(
                map((result: any) => {
                    return new ac.PostRolleAbteilungSetzenErfolgreichAction(result, x.incidentsRolleOptionenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostRolleAbteilungSetzenFehlerAction(error, x.incidentsRolleOptionenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
